import type {ExternalAgentId} from '@/app/flow/components/useExternalAgents';
import * as React from 'react';
import {
  ClaudeIcon,
  CodexIcon,
  CursorIcon,
  LovableIcon,
  ReplitIcon,
} from '@icons';

const agentIconMap: Record<
  ExternalAgentId,
  React.ComponentType<{className?: string}>
> = {
  cursor: CursorIcon,
  'claude-code': ClaudeIcon,
  codex: CodexIcon,
  lovable: LovableIcon,
  replit: ReplitIcon,
};

export const AgentIcon = ({
  agent,
  className,
}: {
  agent: ExternalAgentId;
  className?: string;
}) => {
  const Icon = agentIconMap[agent];
  return <Icon className={className} />;
};
